import React from 'react'

export const ColorStripe = (className ="", ...props) => {

    return (
        <div className={className.className}></div>
    )
}